export default "__VITE_ASSET__536yNA9c__"